<template>
  <div id="order-history" class="column is-full">
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li v-for="(routeBreadcrumb, index) in routeBreadcrumbs" :key="index"><a :href="routeBreadcrumb.path" @click="$router.push(routeBreadcrumb.path)">{{ routeBreadcrumb.name }}</a></li>
      </ul>
    </nav>
    <nav v-if="hasCustomer" class="level">
      <div class="level-item has-text-centered">
        <b-button tag="router-link" to="/product-request" type="is-primary">Create Product Request</b-button>
      </div>
    </nav>
    <b-table :data="orders" :debounce-search="1000" :paginated="true" :per-page="25" :pagination-position="'both'" :striped="true" :hoverable="true" :focusable="true" :mobile-cards="true" :row-class="rowClass">
      <b-table-column v-slot="props" field="purchase_order_number" label="PO #" searchable sortable>
        {{ props.row.purchase_order_number }}
      </b-table-column>
      <b-table-column v-slot="props" field="create_date" label="Created" sortable>
        {{ props.row.create_date | dateShort }}
      </b-table-column>
      <b-table-column v-slot="props" field="status" label="Status" searchable sortable>
        {{ props.row.status | titleCase }}
      </b-table-column>
      <b-table-column v-slot="props" field="needed_date" label="Needed" sortable>
        {{ props.row.needed_date | dateShort }}
      </b-table-column>
      <!--
      <b-table-column v-slot="props" field="amount_total" label="Total" sortable>
        {{ props.row.total | currency }}
      </b-table-column>
      -->
      <b-table-column v-slot="props" field="" label="Actions">
        <b-dropdown>
          <button class="button is-primary" slot="trigger">
            <span>Actions</span>
            <b-icon icon="chevron-down" size="is-small"></b-icon>
          </button>
          <b-dropdown-item :has-link="isEditable(props.row)" :disabled="! isEditable(props.row)">
            <template v-if="isEditable(props.row)">
              <router-link :to="{ path: `/product-request/${ props.row.id }` }"><i class="sl-pencil-1"></i> Edit</router-link>
            </template>
            <template v-else>
              <span v-tooltip.left="editTooltipOptions(props.row)"><i class="sl-pencil-1"></i> Edit</span>
            </template>
          </b-dropdown-item>
          <b-dropdown-item><span @click="downloadOrderReview(props.row.id)"><i class="sl-document-1"></i> Product Request Review</span></b-dropdown-item>
        </b-dropdown>
      </b-table-column>
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>{{ emptyText }}</p>
          </div>
        </section>
      </template>
    </b-table>
    <b-modal :active.sync="isOrderReviewModalActive" scroll="keep">
      <div class="card">
        <header class="card-header">
          <p class="card-header-title has-text-centered">
            Purchase Order: {{ order.purchase_order_number }}; Needed: {{ order.needed_date | dateShort }}
          </p>
        </header>
        <div class="card-content">
          <div class="content">
            <div class="columns">
              <div class="column is-4 is-offset-1">
                <address>
                  <template v-if="order.billing_business_name">{{ order.billing_business_name }}<br></template>
                  <template v-if="order.billing_contact_name">{{ order.billing_contact_name }}<br></template>
                  {{ order.billing_street_address }}<br>
                  <template v-if="order.shipping_street_address_2">{{ order.billing_street_address_2 }}<br></template>
                  {{ order.billing_city }}, {{ order.billing_state }} {{ order.billing_postal_code }}
                </address>
              </div>
              <div class="column is-4 is-offset-2">
                <template v-if="order.shipping_business_name">{{ order.shipping_business_name }}<br></template>
                <template v-if="order.shipping_contact_name">{{ order.shipping_contact_name }}<br></template>
                {{ order.shipping_street_address }}<br>
                <template v-if="order.shipping_street_address_2">{{ order.shipping_street_address_2 }}<br></template>
                {{ order.shipping_city }}, {{ order.shipping_state }} {{ order.shipping_postal_code }}
              </div>
            </div>
            <b-table :data="order.orderItems" :striped="true" :narrowed="true" :hoverable="true" :focusable="true" :mobile-cards="true" class="order-review-table">
              <b-table-column v-slot="props" field="item_code" label="Code" sortable>
                {{ props.row.item_code }}
              </b-table-column>
              <b-table-column v-slot="props" field="item_name" label="Name" sortable>
                {{ props.row.item_name }}
              </b-table-column>
              <!--
                <b-table-column v-slot="props" field="price" label="Price" numeric sortable>
                  {{ props.row.price | currency }}
                </b-table-column>
                -->
              <b-table-column v-slot="props" field="quantity" label="Qty" numeric sortable>
                {{ props.row.quantity }}
              </b-table-column>
              <!--
                <b-table-column v-slot="props" field="subtotal" label="Subtotal" numeric sortable>
                  {{ props.row.subtotal | currency }}
                </b-table-column>
                -->
              <template slot="footer">
                <table class="order-review-table-totals">
                  <tr>
                    <th colspan="4">
                      Item Subtotal ({{ order.item_count }})
                    </th>
                    <td class="has-text-weight-semibold">
                      {{ order.subtotal | currency }}
                    </td>
                  </tr>
                  <tr>
                    <th colspan="4">
                      Sales Tax
                    </th>
                    <td class="has-text-weight-semibold">
                      {{ order.sales_tax | currency }}
                    </td>
                  </tr>
                  <tr>
                    <th colspan="4">
                      Federal Excise Tax (FET)
                    </th>
                    <td class="has-text-weight-semibold">
                      {{ order.federal_excise_tax | currency }}
                    </td>
                  </tr>
                  <!--
                  <tr>
                    <th colspan="4">
                      <i class="sl-alert-1 has-text-danger" v-tooltip.top="shippingTooltipOptions"></i> Shipping:
                    </th>
                    <td class="has-text-weight-semibold">
                      {{ order.shipping | currency }}
                    </td>
                  </tr>
                  -->
                  <tr>
                    <th colspan="4">
                      Product Total:
                    </th>
                    <td class="has-text-weight-bold">
                      {{ order.total | currency }}
                    </td>
                  </tr>
                </table>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import store from '@/store'
import { currency, dateShort, titleCase } from '@/filters'
import { mapGetters, mapActions } from 'vuex'

export default {
  data: function () {
    return {
      isOrderReviewModalActive: false,
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'orders',
      'order'
    ]),
    routeBreadcrumbs () {
      return [
        ...this.$route.meta.breadcrumbs,
      ]
    },
    emptyText () {
      return (this.$wait.is('fetching data')) ? `Loading...` : `No Product Requests`
    },
    hasCustomer () {
      return (this.user.customer_id) ? true : false
    },
    shippingTooltipOptions () {
      return {
        trigger: 'hover',
        content: 'Your shipping amount will be calculated once the product request has been processed at Pneu-Dart'
      }
    }
  },
  methods: {
    ...mapActions([
      'getOrders',
      'downloadOrderReview'
    ]),
    async fetchData () {
      this.$wait.start('fetching data')
      try {
        await this.getOrders({
          filters: [],
          includes: [
            'orderItems'
          ],
          sort: [
            '-create_date'
          ]
        })
      } catch (error) {
        console.log(error)
      }
      this.$wait.end('fetching data')
    },
    rowClass (row, index) {
      switch (row.status) {
        // case 'PENDING_IMPORT':
        // case 'IMPORTED':
        //     return 'has-text-success'
        case 'CANCELED':
          return 'has-text-grey-light'
            // return 'has-text-danger'
        // case 'DRAFT':
        default:
            return ''
      }
    },
    editTooltipOptions (order) {
      return {
        trigger: 'hover',
        content: (this.isSubmitted(order)) ? 'Product request has already been submitted and is uneditable' : ((this.isCanceled(order)) ? 'Product request has been canceled and is uneditable' : '')
      }
    },
    // toggleOrderReviewModal: function (orderId) {
    //   store.commit('RECEIVE_GET_ORDER', this.getOrderById(orderId))
    //   this.isOrderReviewModalActive = true
    // },
    getOrderById (orderId) {
      return this.orders.find((order) => order.id === orderId)
    },
    isEditable(order) {
      return ! this.isCanceled(order) && ! this.isSubmitted(order) && ! this.$wait.any
    },
    isCanceled(order) {
      return ['CANCELED'].includes(order.status)
    },
    isSubmitted(order) {
      return ['PENDING_IMPORT', 'IMPORTED'].includes(order.status)
    },
  },
  filters: {
    currency,
    dateShort,
    titleCase
  },
  created () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  }
}
</script>